import React from 'react';
import Tabs from '@ey/canvascoreservices/TabBar';
import {getTheme} from '../../utils/utils';
import styled from 'styled-components';

export default function TabBar({activeTab, badge, onTabChange, styleName, tabColor, tabs, ellipse, ...props}) {
	return (
		<StyledTabs className="StyledTabs">
			<Tabs
				activeTab={activeTab}
				badge={badge}
				onTabChange={onTabChange}
				styleName={styleName}
				tabColor={tabColor}
				tabs={tabs}
				ellipse={ellipse}
				theme={getTheme()}
				{...props}
			/>
		</StyledTabs>
	);
}

const StyledTabs = styled.section`
	padding-right: var(--px-50);
	.tab-bar {
		.motif-tab-navigation {
			width: 100%;
		}
	}
`;
